// Exact option lists from spec/01 §4.2. Value 'ai-pilih' = "Let AI choose".
export const AI_PICK = 'ai-pilih'

export const FRONTEND_OPTIONS = [
  'Next.js', 'React (Vite)', 'TanStack Start', 'React Router 7 / Remix', 'Astro', 'Vue.js', 'Nuxt',
  'Svelte', 'SvelteKit', 'Solid / SolidStart', 'Qwik', 'Angular', 'HTMX + Server-rendered', 'Flutter',
  'React Native', 'Expo (React Native)', 'SwiftUI (iOS native)', 'Jetpack Compose (Android native)',
  'Tauri (desktop)', 'Electron (desktop)',
]
export const BACKEND_OPTIONS = [
  'Node.js (Express/Fastify)', 'NestJS', 'Hono', 'Elysia (Bun)', 'Bun runtime', 'Deno',
  'Python (FastAPI/Django)', 'Go (Fiber/Echo)', 'Rust (Axum/Actix)', 'Laravel (PHP)', 'Ruby on Rails',
  'Java (Spring Boot)', '.NET (ASP.NET Core)', 'Cloudflare Workers', 'Edge Functions (Vercel/Netlify)',
  'Convex (BaaS)', 'InsForge (BaaS)', 'Supabase (BaaS)', 'Firebase (BaaS)', 'Appwrite (BaaS)', 'Pocketbase (BaaS)',
]
export const DATABASE_OPTIONS = [
  'PostgreSQL', 'Neon (serverless Postgres)', 'Supabase (Postgres)', 'Prisma Postgres', 'MySQL',
  'PlanetScale (MySQL)', 'SQLite', 'Turso (libSQL)', 'Cloudflare D1', 'MongoDB', 'Firebase / Firestore',
  'Convex', 'Redis / Upstash', 'DynamoDB', 'CockroachDB', 'ClickHouse (analytics)', 'Xata',
]
export const DEPLOYMENT_OPTIONS = [
  'Vercel', 'Netlify', 'Cloudflare Pages / Workers', 'Railway', 'Render', 'Fly.io', 'Koyeb', 'Northflank',
  'Deno Deploy', 'AWS (Amplify/ECS/Lambda)', 'Google Cloud (Cloud Run)', 'Azure (App Service)',
  'Hetzner Cloud', 'DigitalOcean (App Platform)', 'VPS (manual)', 'Coolify (self-host PaaS)',
  'Docker / Kubernetes (self-host)',
]
